<template>

  <div>
    <!-- END: Data List -->
    <div id="rough-process-issue-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-body p-10">
            <!-- <div id="vertical-form"> -->
            <div class="flex flex-col justify-between mt-5">
              <!-- BEGIN: Data List -->
              <div class="intro-y overflow-auto">
                <div class="flex items-center">
                  <!-- <h2 class="intro-y text-lg font-medium mr-5">Process Assign</h2> -->
                  <h2 class="intro-y text-lg font-medium mr-5">Purchase No : <span class="ml-2 text-primary-1">{{
                      issue_form.lot_no }}</span></h2>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="intro-y col-span-12">
                  <!-- BEGIN: Input -->
                  <div class="">
                    <div id="input" class="py-5">
                      <div class="preview">
                        <div>
                          <!-- <label class="form-label">Kapan No & Stone Type</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div class="">
                                <div id="input-group-4">Kapan</div>

                                <input id="pos-form-1" v-model="issue_form.kapan" name="kapan" type="text" disabled
                                  class="form-control flex-1" placeholder="Kapan No" />
                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div id="input-group-3" class="">Stone</div>
                              <select class="form-select" v-model="issue_form.stone_id" disabled
                                aria-label="Default select example">
                                <option v-for="item in page_data.stones" :key="item.id" :value="item.id">
                                  {{ item.stone_name }}
                                </option>
                              </select>
                              <!-- <template v-if="form_validate.stone_id.$error">
                                                              <div v-for="(error, index) in form_validate.stone_id.$errors" :key="index" class="text-theme-6 mt-2">
                                                                  {{ error.$message }}
                                                              </div>
                                                          </template> -->
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div>

                                <div class="">
                                  <label for="update-profile-form-6" class="form-label">Issue Type</label>
                                  <TomSelect v-model="issue_form.issue_type" :options="{
                                    placeholder: 'Select Process'
                                  }" class="w-full">
                                    <option value="1">Manager Assign</option>
                                    <option value="2">Process Assign</option>
                                  </TomSelect>
                                </div>

                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div v-if="issue_form.issue_type == 2">

                                  <label for="update-profile-form-6" class="form-label">Select Process <span
                                      class="text-theme-6"> * </span></label>
                                  <TomSelect v-model="issue_form.process_id" @change="get_employee_details()" :options="{
                                    placeholder: 'Select Process'
                                  }" class="w-full">
                                    <option value="">Select Process</option>
                                    <option v-for="(process, ind) in page_data.process_items" :key="ind"
                                      :value="process.id">
                                      {{ process.process_name }}</option>
                                  </TomSelect>
                                  <template v-if="issue_validate.process_id.$error">
                                    <div v-for="(error, index) in issue_validate.process_id.$errors" :key="index"
                                      class="text-theme-6 mt-2">
                                      {{ error.$message }}
                                    </div>
                                  </template>
                                </div>
                                <div v-if="issue_form.issue_type == 1">

                                  <label for="update-profile-form-6" class="form-label">Select Manager <span
                                      class="text-theme-6"> * </span></label>
                                  <TomSelect v-model="issue_form.operator_id" :options="{
                                    placeholder: 'Select Process'
                                  }" class="w-full">
                                    <option value="">Select Manager</option>
                                    <option v-for="(process, ind) in page_data.manager_items" :key="ind"
                                      :value="process.id">
                                      {{ process.first_name }} {{ process.last_name }}</option>
                                  </TomSelect>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="flex items-center mt-3" v-if="issue_form.issue_type == 2">
                          <div class="form-check">
                            <input
                              class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer"
                              value="0" type="radio" name="single_internal" id="single_internal"
                              @change="issue_form.employee_id = ''" v-model="issue_form.external">
                            <label class="form-check-label inline-block text-black text-lg" for="single_internal">
                              Internal
                            </label>
                          </div>
                          <div class="form-check ml-6">
                            <input
                              class="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-1 ml-3 cursor-pointer"
                              value="1" type="radio" name="single_external" id="single_external"
                              @change="issue_form.employee_id = ''" v-model="issue_form.external">
                            <label class="form-check-label inline-block text-black text-lg" for="single_external">
                              External
                            </label>
                          </div>
                        </div>
                        <div class="mt-3" v-if="issue_form.external == '0' && issue_form.issue_type == 2">
                          <label for="update-profile-form-6" class="form-label">Select Employee <span
                              class="text-theme-6">
                              * </span></label>
                          <TomSelect v-model="issue_form.employee_id" :options="{
                            placeholder: 'Select Employee'
                          }" class="w-full">
                            <option value="">Select Employee</option>
                            <option v-for="(emp, ind) in page_data.employee_items" :key="ind" :value="emp.id">{{
                              emp.first_name + ' ' + emp.last_name}}</option>
                          </TomSelect>
                          <template v-if="issue_validate.employee_id.$error">
                            <div v-for="(error, index) in issue_validate.employee_id.$errors" :key="index"
                              class="text-theme-6 mt-2">
                              {{ error.$message }}
                            </div>
                          </template>
                        </div>
                        <div class="mt-3" v-else-if="issue_form.external == '1' && issue_form.issue_type == 2">
                          <label for="update-profile-form-6" class="form-label">Process Party <span
                              class="text-theme-6"> *
                            </span></label>
                          <TomSelect v-model="issue_form.employee_id" :options="{
                            placeholder: 'Select Party'
                          }" class="w-full">
                            <option value="">Select Party</option>
                            <option v-for="(party, ind) in page_data.process_party_items" :key="ind" :value="party.id">{{
                              party.first_name + ' ' + party.last_name }}</option>
                          </TomSelect>
                          <template v-if="issue_validate.employee_id.$error">
                            <div v-for="(error, index) in issue_validate.employee_id.$errors" :key="index"
                              class="text-theme-6 mt-2">
                              {{ error.$message }}
                            </div>
                          </template>
                        </div>
                        <div class="mt-3">
                          <!-- <label class="form-label">No. of Pieces & Total Weight</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div>

                                <div class="">
                                  <div id="input-group-3">Available Pieces</div>
                                  <input type="text" class="form-control" name="piece" disabled
                                    v-model="issue_form.avail_pcs" aria-describedby="input-group-3" />
                                </div>

                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div id="input-group-4">Available Weight (Ct)</div>
                                <input type="text" class="form-control" name="weight" disabled
                                  v-model="issue_form.avail_wt" aria-describedby="input-group-4" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3" v-if="issue_form.issue_type == 2">
                          <!-- <label class="form-label">No. of Pieces & Total Weight</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div>

                                <div class="">
                                  <div id="input-group-3" :class="{ 'border-theme-6': issue_validate.weight.$error }">
                                    Pieces
                                    <span class="text-theme-6"> * </span>
                                  </div>
                                  <input type="text" class="form-control" name="piece"
                                    :class="{ 'border-theme-6': issue_validate.pieces.$error }" autocomplete="off"
                                    @keypress="$h.preventInvalidInput" v-model="issue_form.pieces"
                                    placeholder="No of Pieces" aria-describedby="input-group-3" />
                                </div>
                                <template v-if="issue_validate.pieces.$error">
                                  <div v-for="(error, index) in issue_validate.pieces.$errors" :key="index"
                                    class="text-theme-6 mt-2">
                                    {{ error.$message }}
                                  </div>
                                </template>

                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div id="input-group-4" :class="{ 'border-theme-6': issue_validate.weight.$error }">
                                  Weight
                                  (Ct) <span class="text-theme-6"> * </span></div>
                                <input type="text" class="form-control" name="weight"
                                  :class="{ 'border-theme-6': issue_validate.weight.$error }" autocomplete="off"
                                  @keypress="$h.preventInvalidInput" v-model="issue_form.weight" placeholder="Weight"
                                  aria-describedby="input-group-4" />
                              </div>
                              <template v-if="issue_validate.weight.$error">
                                <div v-for="(error, index) in issue_validate.weight.$errors" :key="index"
                                  class="text-theme-6 mt-2">
                                  {{ error.$message }}
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <!-- <label class="form-label">Stone && Est Value</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>

                              <div class="">

                              </div>
                            </div>
                            <div>
                              <div class="mt-2 sm:mt-0">
                                <div class="flex justify-end items-center mt-5">
                                  <button type="button" :disabled="page_data.i_loading == true"
                                    class="btn btn-secondary w-24 m-auto mr-3" data-dismiss="modal"
                                    href="javascript:;">Cancel</button>
                                  <button type="button" @click="process_issue" :disabled="page_data.i_loading == true"
                                    class="btn btn-primary w-24 m-auto"> Issue
                                    <LogInIcon v-if="page_data.i_loading == false" class="h-4 w-4 ml-2 -mt-1" />
                                    <LoadingIcon v-if="page_data.i_loading == true" icon="oval" color="white"
                                      class="w-4 h-4 ml-2" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END: Input -->
                </div>
              </div>
              <!-- END: Data List -->
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Single Process Assign Modal -->
  </div>

</template>

<script setup>
/* eslint-disable */
import {
  BASE_URL
} from '@/constants/config'
import {
  useVuelidate
} from '@vuelidate/core'
import axios from 'axios'
import cash from 'cash-dom'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  integer
} from '@vuelidate/validators'
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch
} from 'vue'
import {
  helper as $h
} from '@/utils/helper'
import router from '@/router'
import Swal from 'sweetalert2'
import {
  useStore
} from '@/store'

const swal = inject('$swal')
const store = useStore()
const user_details = computed(() => store.state.user.currentUser)
const settings = computed(() => store.state.user.settings)

const page_data = reactive({
      party_details: [],
      purchase_party_details: [],
      loading: false,
      r_loading: false,
      i_loading: false,
      process_items: [],
      employee_items: [],
      rejection_items: [],
      manager_items: [],
      process_party_items: [],
      diamond_type_items: [],
      total: [],
      home_party: ""

    })


const issue_form = reactive({
  issue_type: user_details.value.user_role == 1 ? '1' : '2',
  operator_id: '',
  pieces: '',
  weight: '',
  avail_pcs: '',
  avail_wt: '',
  purchase_id: '',
  process_id: '',
  employee_id: '',
  external: '0',
  lot_no: '',
  kapan: '',
  stone_id: '',
})

const issue_rules = {
      pieces: {
        required,
        integer
      },
      weight: {
        required,
      },
      purchase_id: {
        required,
      },
      process_id: {
        required,
      },
      employee_id: {
        required,
      }
    }

    const issue_validate = useVuelidate(issue_rules, toRefs(issue_form))


const resetForm = (item) => {

  cash('#rough-process-issue-modal').modal('show')

  issue_form.purchase_id = item.id
  issue_form.kapan = item.voucher_no
  issue_form.lot_no = item.lot_no
  issue_form.avail_pcs = item.cr_pcs
  issue_form.avail_wt = item.cr_wt
  issue_form.stone_id = String(item.stone_type)

  get_manager_details()
  get_process_details(user_details.value.account_id)
}

const get_manager_details = (id) => {
  if (id != 0) {
    const params = {
      user_id: id,
      // process_type: window.btoa('bunch')
    }
    if (id != '0') {
      axios({
        url: 'api/master/dp_managers',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            'Accept': 'application/json'
          }
        }
      }).then((res) => {
        page_data.manager_items = res.data.items

        var i = page_data.manager_items.length;
        while (i--) {
          if (page_data.manager_items[i]['id'] == user_details.value.account_id) {
            page_data.manager_items.splice(i, 1);
          }
        }
        issue_form.operator_id = String(page_data.manager_items[0].id)
      })
    } else {
      page_data.manager_items = []
      process.operator_id = ''
    }
  }
}

const get_employee_details = () => {
  const params = {
    manager_id: window.btoa(user_details.value.account_id),
    process_id: window.btoa(issue_form.process_id),
    process_type: window.btoa('bunch'),
  }
  if (issue_form.process_id != '') {

    axios({
      url: 'api/master/get_employees_by_manager_process',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      config: {
        headers: {
          'Accept': 'application/json'
        }
      }
    }).then((res) => {
      page_data.employee_items = res.data.items
      issue_form.employee_id = ''
    })
    axios({
      url: 'api/master/get_jober_details_by_process',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      config: {
        headers: {
          'Accept': 'application/json'
        }
      }
    }).then((res) => {
      page_data.process_party_items = res.data.items
      issue_form.party_id = ''
    })
  } else {
    page_data.employee_items = []
    issue_form.employee_id = ''
    page_data.process_party_items = []
    issue_form.party_id = ''
  }
}

const get_process_details = (id) => {
  if (id != 0) {
    const params = {
      user_id: id,
      process_type: window.btoa('bunch')
    }
    if (id != '0') {
      axios({
        url: 'api/master/manager_processes',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            'Accept': 'application/json'
          }
        }
      }).then((res) => {
        page_data.process_items = res.data.items
        issue_form.process_id = ''
      })
    } else {
      page_data.process_items = []
      process.process_id = ''
    }
  }
}

// Process Assign
    const process_assign = async () => {

      issue_validate.value.$touch()
      if (issue_validate.value.$invalid) {
        swal('Error', 'Fields are empty.', 'error');
        return
      }

      const params = {
        pieces: (issue_form.pieces != '' ? window.btoa(issue_form.pieces) : ''),
        weight: (issue_form.weight != '' ? window.btoa(issue_form.weight) : ''),
        purchase_id: (issue_form.purchase_id != '' ? window.btoa(issue_form.purchase_id) : ''),
        process_id: (issue_form.process_id != '' ? window.btoa(issue_form.process_id) : ''),
        employee_id: (issue_form.employee_id != '' ? window.btoa(issue_form.employee_id) : ''),
        external: (issue_form.external != '' ? window.btoa(issue_form.external) : ''),
        ip: localStorage.getItem('sk_key')
      }

      let promise_url = ''

      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {
            swal('Warning', data.message, 'warning');
          } else {
            swal('Success', data.message, 'success');

            issue_form.pieces = ''
            issue_form.weight = ''
            issue_form.purchase_id = ''
            issue_form.process_id = ''
            issue_form.employee_id = ''
            issue_form.external = '0'

            cash('#rough-process-assign-modal').modal('hide')
            validate.value.$reset()
            initTabulator()
          }
        })
        .catch(_error => {
          swal('Error', 'Something went wrong.', 'error');
        });

    }

    // Process Cancel
    const process_issue = async () => {

      if (issue_form.issue_type == 1) {

        const params = {
          operator_id: (issue_form.operator_id != '' ? window.btoa(issue_form.operator_id) : ''),
          issue_type: (issue_form.issue_type != '' ? window.btoa(issue_form.issue_type) : ''),
          purchase_id: (issue_form.purchase_id != '' ? window.btoa(issue_form.purchase_id) : ''),
          ip: localStorage.getItem('sk_key')
        }

        let promise_url = 'api/kpn/prrp'

        page_data.i_loading = true

        let promise = axios({
          url: promise_url,
          method: "POST",
          data: params,
          baseURL: BASE_URL,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),

          },
          config: {
            headers: {
              Accept: "application/json"
            }
          }
        });
        return promise
          .then(result => result.data)
          .then(data => {

            if (data.status == 'error') {
              swal('Warning', data.message, 'warning');
              page_data.i_loading = false
            } else {
              swal('Success', data.message, 'success');

              issue_form.pieces = ''
              issue_form.weight = ''
              issue_form.purchase_id = ''
              issue_form.process_id = ''
              issue_form.employee_id = ''
              issue_form.external = '0'
              page_data.i_loading = false

              cash('#rough-process-issue-modal').modal('hide')
              issue_validate.value.$reset()
              // router.push('/purchase/rough/issue')
              initTabulator()
            }
          })
          .catch(_error => {
            page_data.i_loading = false
            swal('Error', 'Something went wrong.', 'error');
          });
      } else {

        issue_validate.value.$touch()
        if (issue_validate.value.$invalid) {
          // swal('Error', 'Fields are empty.', 'error');
          return
        }

        const params = {
          pieces: (issue_form.pieces != '' ? window.btoa(issue_form.pieces) : ''),
          weight: (issue_form.weight != '' ? window.btoa(issue_form.weight) : ''),
          purchase_id: (issue_form.purchase_id != '' ? window.btoa(issue_form.purchase_id) : ''),
          process_id: (issue_form.process_id != '' ? window.btoa(issue_form.process_id) : ''),
          employee_id: (issue_form.employee_id != '' ? window.btoa(issue_form.employee_id) : ''),
          external: (issue_form.external != '0' ? window.btoa(issue_form.external) : ''),
          issue_type: (issue_form.issue_type != '' ? window.btoa(issue_form.issue_type) : ''),
          ip: localStorage.getItem('sk_key')
        }

        let promise_url = 'api/kpn/prrp'

        page_data.i_loading = true

        let promise = axios({
          url: promise_url,
          method: "POST",
          data: params,
          baseURL: BASE_URL,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),

          },
          config: {
            headers: {
              Accept: "application/json"
            }
          }
        });
        return promise
          .then(result => result.data)
          .then(data => {

            if (data.status == 'error') {
              swal('Warning', data.message, 'warning');
              page_data.i_loading = false
            } else {
              swal('Success', data.message, 'success');

              issue_form.pieces = ''
              issue_form.weight = ''
              issue_form.purchase_id = ''
              issue_form.process_id = ''
              issue_form.employee_id = ''
              issue_form.external = '0'
              page_data.i_loading = false

              cash('#rough-process-issue-modal').modal('hide')
              issue_validate.value.$reset()
              // router.push('/purchase/rough/issue')
              initTabulator()
            }
          })
          .catch(_error => {
            page_data.i_loading = false
            swal('Error', 'Something went wrong.', 'error');
          });
      }

    }

defineExpose({
  resetForm
})


</script>
